import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IPagingReq, IPagingRes } from '@/api/paging.ts'
import { createUrl } from '@/util/url.ts'
import { IAlert, IProtectee, IProtector } from '@/api/notification/getNotificationSos.ts'

export interface IPosition {
    latitude: number;
    longitude: number;
    address?: string;
}

interface IReqGetFallDetection extends IPagingReq {
}

export enum FallDetectionResultType {
    EMERGENCY_119 = '119출동',
    MALFUNCTION = '오작동',
    ETC = '기타'
}

export interface IAlertFallDetection {
    id: number
    alert: IAlert
    protectee: IProtectee
    protector: IProtector
}

export interface IAlertFallDetectionItem {
    id: number
    alert: IAlert
    protectee: IProtectee
    protector: IProtector
}

export const apiGetNotificationFallDetection = async ({ pageNum, pageSize }: IReqGetFallDetection, query?: string) => {
    const pathToCall = '/alert/falldetection';
    return await apiGet<IPagingRes<IAlertFallDetectionItem[]>>(createUrl(pathToCall, {
        query: query,
        pageNum: pageNum,
        pageSize: pageSize
    }))
}

const useQueryGetNotificationFallDetection = (props: IReqGetFallDetection, query?: string) => {
    return useQuery({
        queryKey: QueryCacheKeys.notification.apiGetNotificationFallDetection(query, props),
        queryFn: async () => {
            const { data } = await apiGetNotificationFallDetection(props, query)
            return data
        },
    })
}

export default useQueryGetNotificationFallDetection

export { EmergencyAlertConfirmStatus, EmergencyAlertType } from './getNotificationSos' 
